module.exports = __webpack_public_path__ + "img/Accountor-37-lowres.7d85dff7.jpg";